exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".developers-icon{font-size:14em}.docs-link{display:inline;color:#5f8f93;margin-left:40%;margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/routes/developers.styl
// module id = 492
// module chunks = 0